<template>
  <div class="page">
    <div>
      <Panel
        lineColor="var(--primary-color)"
        style="margin-bottom: 0px; display: flex;"
      >
        <FormAutocomplete
          label="Selecione um fornecedor"
          v-model="fornecedorId"
          :options="fornecedores"
          class="mt-3"
        />
        <DataTable
          :headers="headers"
          :endpoint="endpoint"
          sortBy="numpedido"
          :sortDesc="true"
          ref="datatable"
          search
        >
          <template v-slot:numpedido="{ row }">
            <div class="d-flex mb-n7 mt-2 ml-3">
              <v-chip
                :color="getStatusPedidoColor(row.statuspedido)"
                class="ml-auto font-weight-bold"
                small
              >
                {{ getStatusPedido(row.statuspedido) }}
              </v-chip>
            </div>
            <strong>{{ row.numpedido }}</strong> <br />
            <span>{{ row.datapedido | formatDate }}</span> <br />
            <span>Total: {{ row.totalliquido | formatMoney }}</span>
          </template>
          <template v-slot:nomecliente="{ row }">
            <strong>{{ row.nomecliente }}</strong> <br />
            <span>{{ row.emailcliente }}</span> <br />
            <span>{{ formatTelefone(row.telefonecliente) }}</span>
          </template>
          <template v-slot:nota="{ col }">
            <span v-if="col">
              <span style="font-size: 2.5em;">{{ avaliacoes[col].smile }}</span>
              <h4>{{ avaliacoes[col].text }}</h4>
            </span>
            <span v-else>Não avaliado</span>
          </template>
          <template v-slot:comentario="{ col }">
            <span v-if="col">{{ col }}</span>
            <span v-else>Sem comentário</span>
          </template>
        </DataTable>
      </Panel>
    </div>
  </div>
</template>

<script>
import DataTable from "@/components/DataTable";
import Panel from "@/components/Panel";
import FormAutocomplete from "@/components/form/FormAutocomplete";
import OrderStatus from "../../utils/orderStatus";
import { PEDIDO_AVALIACOES } from "@/store/actions/pedido";
import { FORNECEDOR_ALL } from "@/store/actions/fornecedor";

export default {
  name: "AvaliacaoClienteAdmin",
  components: {
    DataTable,
    Panel,
    FormAutocomplete
  },
  data: () => ({
    fornecedores: [],
    fornecedorId: null,
    headers: [
      { text: "Pedido", value: "numpedido" },
      { text: "Cliente", value: "nomecliente" },
      { text: "Avaliação", value: "nota", align: "center" },
      { text: "Comentário do cliente", value: "comentario", align: "center" }
    ],
    loadingRow: {},
    avaliacoes: PEDIDO_AVALIACOES
  }),
  computed: {
    endpoint() {
      return `/api/v4/orders/avaliations/listForTable/${this.fornecedorId}`;
    }
  },
  methods: {
    getFornecedores() {
      this.$store.dispatch(FORNECEDOR_ALL).then(response => {
        this.fornecedores = (response || []).map(v => {
          return {
            ...v,
            text: v.nome,
            value: v.idfornecedor
          };
        });
      });
    },
    formatTelefone(phone) {
      const telefone = Array.isArray(phone) ? phone[0] : phone;
      if (telefone.length === 10) {
        return `(${telefone.substring(0, 2)}) ${telefone.substring(
          2,
          6
        )}-${telefone.substring(6)}`;
      } else if (telefone.length === 11) {
        return `(${telefone.substring(0, 2)}) ${telefone.substring(
          2,
          7
        )}-${telefone.substring(7)}`;
      } else if (telefone.length === 13) {
        return `${telefone.substring(0, 2)} (${telefone.substring(
          2,
          4
        )}) ${telefone.substring(4, 9)}-${telefone.substring(9)}`;
      }
      return telefone;
    },
    getStatusPedido(status) {
      return OrderStatus && OrderStatus.OrderStatusLabel
        ? OrderStatus.OrderStatusLabel[status]
        : "";
    },
    getStatusPedidoColor(status) {
      return OrderStatus && OrderStatus.OrderStatusColor
        ? OrderStatus.OrderStatusColor[status]
        : "";
    }
  },
  created() {
    this.getFornecedores();
  }
};
</script>
